import { Injectable } from '@angular/core';
import { BpEngagement } from '../model/bp-engagement';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';

@Injectable({
    providedIn: 'root'
  })
  export class BpEngagementService{
  
    constructor(private _restClientService : RestClientService) { }

    getBpEngagementBycodeclient(codeclient){
        
        return this._restClientService.load<BpEngagement>('bp-engagement/bp-engagement-by-codeclient/'+codeclient);
    }
  
  

}      

    